export function getVisibleTrimHandle(
  isNearLeftEdge: boolean,
  isNearRightEdge: boolean,
  mouseX: number,
  segmentLeft: number,
  segmentRight: number
): 'start' | 'end' | null {
  if (!isNearLeftEdge && !isNearRightEdge) {
    return null;
  }
  if (isNearLeftEdge && isNearRightEdge) {
    const distanceToLeft = Math.abs(mouseX - segmentLeft);
    const distanceToRight = Math.abs(mouseX - segmentRight);
    return distanceToLeft < distanceToRight ? 'start' : 'end';
  }
  return isNearLeftEdge ? 'start' : 'end';
}
